import '../assets/NcAppNavigationList-CUnaMQQD.css';
import { n as t } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const s = {
  name: "NcAppNavigationList"
};
var e = function() {
  var a = this, n = a._self._c;
  return n("ul", { staticClass: "app-navigation-list" }, [a._t("default")], 2);
}, i = [], r = /* @__PURE__ */ t(
  s,
  e,
  i,
  !1,
  null,
  "ac3baea0",
  null,
  null
);
const c = r.exports;
export {
  c as default
};
